
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { TopicItemProps } from ".";
import { loading, index, options } from "store/topic";

interface ApiTopicInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiTopicOutputProps = OutputBaseProps<{ list: TopicItemProps[]; pagination?: PaginationProps; }>

export const apiTopicIndex = async (data: ApiTopicInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTopicOutputProps>("/api/topics", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiTopicOptions = async (data: { q?: string }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTopicOutputProps>("/api/topics", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};